import { render, staticRenderFns } from "./ShowOrder.vue?vue&type=template&id=4566b0b6"
import script from "./ShowOrder.vue?vue&type=script&lang=js"
export * from "./ShowOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports